import axios, { AxiosResponse } from 'axios';
import { createRequestConfig } from './utils';
import EqMaint, { EqMaintCount } from '../models/data/EqMaint';
import EqMaintRequest from '../models/requests/GetEqMaint';

// 設備点検実績情報の取得関数
export default function requestEqMaintList(
  url: string,
  params?: EqMaintRequest,
): Promise<AxiosResponse<EqMaint[]>> {
  const config = createRequestConfig({ params });
  return axios.get<EqMaint[]>(url, config);
}

// 設備点検実績情報件数の取得関数
export function requestCountEqMaint(
  url: string,
  params?: EqMaintRequest,
): Promise<AxiosResponse<EqMaintCount>> {
  const config = createRequestConfig({ params });
  return axios.get<EqMaintCount>(url, config);
}
